import { render, staticRenderFns } from "./TripLoadErrorSection.vue?vue&type=template&id=a01c8fe4&"
import script from "./TripLoadErrorSection.vue?vue&type=script&lang=ts&"
export * from "./TripLoadErrorSection.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports